




















import {
  Component, Prop, PropSync, Watch, Vue,
} from 'vue-property-decorator';
import Choice from '@/models/entry/Choice';

@Component
export default class ExamRadio extends Vue {
  @Prop()
  private choices: Choice[];

  @PropSync('choiceCodes')
  private answer: string[];

  private currentChoice: Choice = new Choice();

  // UI制御フラグ
  private isSeletBodyVisible = false;

  mounted() {
    this.init();
  }

  @Watch('answer', { deep: true })
  init() {
    if (this.answer.length > 0) {
      const code = this.answer[0];
      const selectChoice = this.choices.find((choice) => choice.choiceCode === code) as Choice;
      this.currentChoice = selectChoice;
      return;
    }
    this.currentChoice = new Choice();
  }

  isSelectedCheck(code: string) {
    return !!this.answer.find((selectedCode) => selectedCode === code);
  }

  select(code: Choice) {
    this.answer.length = 0;
    this.answer.push(code.choiceCode);
    this.currentChoice = code;
    this.isSeletBodyVisible = false;
  }

  get selectStyle() {
    if (this.isSeletBodyVisible) {
      return { 'z-index': 500 };
    }
    return {};
  }

  get selectBodyStyle() {
    if (this.isSeletBodyVisible) {
      return { display: 'block', top: '63px' };
    }
    return {};
  }
}
